import Icon from '../components/Icon.vue'

Icon.register({
  wallet: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M461.2 128c28 0 50.8 21.5 50.8 48v256c0 26.5-22.8 48-50.8 48h-397.2c-35.3 0-64-28.7-64-64v-320c0-35.3 28.7-64 64-64h368c26.5 0 48 21.5 48 48 0 8.8-7.2 16-16 16h-384c-8.8 0-16 7.2-16 16s7.2 16 16 16h381.2zM416 336c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/wallet.js
// module id = 2100
// module chunks = 0